<template>
  <div class="home">
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">
          <b>首页</b>
        </router-link>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="content">
      <!-- 快捷导航 -->
      <el-row :gutter="24">
        <el-col :span="24">
          <el-card class="box-card indexpanel">
            <div slot="header" class="clearfix">
              <span>快捷导航</span>
            </div>
            <span>
              <router-link to="/article">
                <el-button
                  :round="true"
                  :plain="true"
                  class="text item"
                  type="primary"
                  >新闻资讯</el-button
                >
              </router-link>
              <router-link to="/product">
                <el-button
                  :round="true"
                  :plain="true"
                  class="text item"
                  type="primary"
                  >产品管理</el-button
                >
              </router-link>
              <router-link to="/producttype">
                <el-button
                  :round="true"
                  :plain="true"
                  class="text item"
                  type="primary"
                  >产品类型维护</el-button
                >
              </router-link>
              <router-link to="/siteinfo">
                <el-button
                  :round="true"
                  :plain="true"
                  class="text item"
                  type="primary"
                  >网站信息维护</el-button
                >
              </router-link>
              <router-link to="/column">
                <el-button
                  :round="true"
                  :plain="true"
                  class="text item"
                  type="primary"
                  >网站栏目维护</el-button
                >
              </router-link>
            </span>
          </el-card>
        </el-col>
      </el-row>
      <!-- 浏览排行 -->
      <el-row :gutter="24">
        <el-col :span="12">
          <el-card class="box-card" shadow="always">
            <div class="clearfix" slot="header">
              <span>热门资讯</span>
              <router-link to="/article">
                <el-button style="float: right; padding: 3px 0" type="text"
                  >更多</el-button
                >
              </router-link>
            </div>
            <div class="index-card">
              <el-table :data="newsList" border stripe style="width: 100%">
                <el-table-column
                  prop="title"
                  label="标题"
                  min-width="55%"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <a
                      :href="domainFront + '/news/' + scope.row.id + '.html'"
                      target="_blank"
                      class="el-link el-link--default is-underline"
                    >
                      <span>{{ scope.row.title }}</span>
                    </a>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="viewCount"
                  label="浏览量"
                  min-width="15%"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="createTime"
                  label="添加时间"
                  min-width="30%"
                  align="center"
                ></el-table-column>
              </el-table>
            </div>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="box-card" shadow="always">
            <div class="clearfix" slot="header">
              <span>热门产品</span>
              <router-link to="/product">
                <el-button style="float: right; padding: 3px 0" type="text"
                  >更多</el-button
                >
              </router-link>
            </div>
            <div class="index-card">
              <el-table :data="productsList" border stripe style="width: 100%">
                <el-table-column
                  prop="name"
                  label="名称"
                  min-width="55%"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <a
                      :href="
                        domainFront +
                        '/product' +
                        scope.row.productType.productTypeParent.id +
                        '/' +
                        scope.row.typeID +
                        '/' +
                        scope.row.id +
                        '.html'
                      "
                      target="_blank"
                      class="el-link el-link--default is-underline"
                    >
                      <span>{{ scope.row.name }}</span>
                    </a>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="viewCount"
                  label="浏览量"
                  min-width="15%"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="createTime"
                  label="添加时间"
                  min-width="30%"
                  align="center"
                ></el-table-column>
              </el-table>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <!-- 版权 -->
      <div class="copyright">Copyright ©️{{ year }} 太原恒戈科技有限公司 提供技术支持</div>
    </div>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
export default {
  name: "home",
  components: {},
  data() {
    return {
      domainFront: url.getDomainFront(),
      year: new Date().getFullYear(),
      newsList: [],
      productsList: [],
    };
  },
  methods: {
    //获取热门新闻
    getNews() {
      var _this = this;
      var link = url.getArticle("gethot");
      $.get(link, { takeCount: 5 }, (res) => {
        _this.newsList = res;
      });
    },
    //获取热门产品
    getProducts() {
      var _this = this;
      var link = url.getProduct("gethot");
      $.get(link, { takeCount: 5 }, (res) => {
        _this.productsList = res;
      });
    },
  },
  mounted() {
    this.getNews();
    this.getProducts();
  },
};
</script>

<style  scoped>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background-color: #f2f2f2;
}
.content {
  padding-top: 20px;
}
.indexpanel .text {
  font-size: 14px;
}

.indexpanel .item {
  margin-bottom: 18px;
  margin-left: 10px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
.box-card {
  margin-bottom: 15px;
}
.lineItem {
  line-height: 2em;
  text-align: center;
  font-size: 13px;
}
.lineTitle {
  letter-spacing: 2px;
  font-weight: bold;
}
.lineLink {
  font-size: 12px;
}
.copyright {
  margin-top: 50px;
  font-size: 12px;
  text-align: center;
  color: #888;
  letter-spacing: 1px;
  line-height: 2em;
}
</style>
